const FormResources = {

    form_data:{
        name:       '',
        note:       '',
        subject:    '',
        email_body: '',
        pass:       false,
        questions: []
    },

    form_backup:{
        name:       '',
        note:       '',
        subject:    'Housekeeping Survey',
        email_body: '',
        pass:       false,
        questions: []
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'note',
            ref:        'note_input',
            ref_alt:    'note_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Subject:',
            model_name: 'subject',
            ref:        'subject_input',
            ref_alt:    'subject_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Email body:',
            model_name: 'email_body',
            ref:        'email_body_input',
            ref_alt:    'email_body_input_alt',
            required:   true,
        },
       
    ]

}

export default FormResources;